import axios from 'axios'
import Promise from 'promise'
import PinkApi from './utils/PinkApi'
import qs from 'qs';

// 定义一个 App mixin 对象
var AppMixin = {
  baseUrl: 'http://api.kemengjizhang.com/v1.0/mall',
  uid:'',
  channel:1,
  methods: {
    get: function (path, params) {
      return axios.get(AppMixin.baseUrl+path, {params:params})
    },
    post: function (path, params) {
      let data = qs.stringify(params)
      return axios.post(AppMixin.baseUrl+path, data, {
        headers: {
          'Content-Type':"application/x-www-form-urlencoded",
					'channel':AppMixin.channel
        }
      })
    },
    createUrl() {
      var url = location.search; //获取url中"?"符后的字串
      var theRequest = {};
      if (url.indexOf("?") != -1) {
        var strs, str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    sendPhoneNum(params){
      return this.post('/user/send_reg_sms',params)
    },
    sendCode(params,channel){
      AppMixin.channel = channel;
      return this.post('/signup',params)
    },
    scrollToTop:function(scrollDuration){
      const scrollHeight = window.scrollY,
        scrollStep = Math.PI / ( scrollDuration / 15 ),
        cosParameter = scrollHeight / 2;
        let scrollCount = 0,
        scrollMargin,
        scrollInterval = setInterval( function() {
          if ( window.scrollY != 0 ) {
            scrollCount = scrollCount + 1;
            scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
            window.scrollTo(0, ( scrollHeight - scrollMargin ) );
          }
          else clearInterval(scrollInterval);
        }, 15 );
    },
    isIos(){
      let u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    }
  }
}

export default AppMixin;



// WEBPACK FOOTER //
// ./src/AppMixin.js